import { render, staticRenderFns } from "./TeamMembersPrintable.vue?vue&type=template&id=9b7c9bce&"
import script from "./TeamMembersPrintable.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMembersPrintable.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports